<template>
    <div class="formula">
        <div class="formula-input" contenteditable="true" v-html="formulaModel"
             @blur="(event) => formulaModel = extractFormulaFromDOM(event.target)"></div>
        <ul class="formula-items mt-2">
            <li v-for="item in itemsModel">
                <span class="badge badge-light" @click="this.formulaModel = formula + item.code">{{ item.name }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "FormulaComponent",
    props: {
        formula : {
            type: String,
            default() {
                return '';
            }
        },
        items : {
            type: Array,
            default() {
                return [];
            }
        },
    },
    methods: {
        extractFormulaFromDOM(element) {
            let result = '';
            
            const nameToCodeMap = {};
            this.items.forEach(item => {
                nameToCodeMap[item.name] = item.code;
            });

            const processNode = (node) => {
                if (node.nodeType === 3) {
                    result += node.textContent;
                } else if (node.nodeType === 1) {
                    if (node.classList.contains('badge')) {
                        const name = node.textContent.trim();
                        if (nameToCodeMap[name]) {
                            result += nameToCodeMap[name];
                        } else {
                            result += name;
                        }
                    } else if (node.nodeName === 'BR') {
                        result += '\n';
                    } else {
                        node.childNodes.forEach(processNode);
                    }
                }
            };

            element.childNodes.forEach(processNode);

            return result.replace(/\u200B/g, '').replace(/\u00A0/g, ' ');
        }
    },
    computed: {
        formulaModel: {
            get() {
                let items = this.items.reduce((object, item) => (object[item.code.replace(/{|}/g, '')] = item.name, object), {});

                const parts = this.formula.split(/({[^{}]+})/);

                let formulaArray = parts.map((part) => {
                    const match = part.match(/{([^{}]+)}/);
                    if (match && items[match[1]]) {
                        const name = items[match[1]];
                        // &#8203; (zero-width space) adds an editable position after the contenteditable="false" badge,
                        // otherwise the caret can't be placed after a variable. It is stripped when reading from the DOM.
                        return `<span class="badge badge-light" style="cursor: default; line-height: 13px;" contenteditable="false">${name}</span>&#8203;`;
                    }
                    return `<span>${part.replace(/ /g, '\u00A0')}</span>`;
                });

                return formulaArray.join('');
            },
            set(newValue) {
                this.$emit('update:formula', newValue)
            }
        },
        itemsModel() {
            return this.items.filter((item) => this.formula.indexOf(item.code) === -1)
        }
    }
}
</script>

<style scoped>
[contenteditable] {
    outline: 0 solid transparent;
}

.formula-input {
    padding: 8px 0;
    border-bottom: 1px solid #ddd;
    min-height: calc(38px + 2px);
    white-space: pre-wrap;
}

.formula-input:focus {
    border-bottom: 2px solid #009688;
}


.formula-input span.badge{
    height: 20px;
}

.formula-input span:not(.badge){
    line-height: 20px;
}

.formula-items{
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    column-gap: 10px;
    overflow-x: auto;
    height: 30px;
}

.formula-items span:hover{
    cursor: pointer;
    background: #ebeaea;
}

</style>
